import { PopoverContent } from '@components/designSystem/Popover'
import ShelfInfoPopoverContent from '@components/storeMap/floor/ShelfInfoPopoverContent'

import type { StoreMapContextType } from '@components/storeMap/provider/StoreMapContext'

type Props = Required<Pick<StoreMapContextType, 'hoveredShelf'>> & Pick<StoreMapContextType, 'activeLayers'>

function ShelfInfoPopover({ hoveredShelf, activeLayers }: Props) {
  const { element, shelf } = hoveredShelf

  return (
    <PopoverContent
      triggerRef={element}
      isOpen={true}
      isNonModal={true}
      aria-label={`Shelf info popover for shelf ${shelf.id}`}
      dialogClassName='bg-bg-primary-solid text-white'
    >
      <ShelfInfoPopoverContent shelf={shelf} activeLayers={activeLayers} />
    </PopoverContent>
  )
}

export default ShelfInfoPopover